import axiosClient from "./axiosClient";

const campaignApi = {
    // Cờ X2 hoàn tiền (public) cho nudge — { active, multiplier }
    getAppX2Status: () => axiosClient.get("campaign/app-x2-status"),
};

export default campaignApi;
